import { render, staticRenderFns } from "./Grupos.vue?vue&type=template&id=06cc4c96&"
import script from "./Grupos.vue?vue&type=script&lang=js&"
export * from "./Grupos.vue?vue&type=script&lang=js&"
import style0 from "./Grupos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports